module.exports = __webpack_public_path__ + "static/media/advertising-terms.fr.09c0812a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/fr/advertising-terms.fr.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/fr/advertising-terms.fr.pdf
// module chunks = 18